import { jsx as _jsx } from "react/jsx-runtime";
import { AlertAttributeTypes } from '../../../typings/enums';
import AlertSelectField from '../AlertSelectField';
import AlertTextField from '../AlertTextField';
import ApprovedTrnxRadio from '../../molecules/ApprovedTrnxRadio';
import { getAttributeError } from '../../../redux/alertsForm/actionsHelpers';
var InputField = function (_a) {
    var alertId = _a.alertId, attributeKey = _a.attributeKey, alertFormData = _a.alertFormData, currentAlertData = _a.currentAlertData, inputRef = _a.inputRef;
    var attributes = alertFormData.attributes, dataErrors = alertFormData.dataErrors;
    switch (attributeKey) {
        case AlertAttributeTypes.ApprovedTransactionType:
            return (_jsx(ApprovedTrnxRadio, { alertId: alertId, inputKey: attributeKey, inputValue: attributes[attributeKey].value, inputError: dataErrors.find(function (error) { return error.key === attributeKey; })
                    ? getAttributeError(attributeKey).value
                    : '', inputRef: inputRef }));
        case AlertAttributeTypes.AvailableCreditThresholdAmount:
        case AlertAttributeTypes.BalanceExceedsThresholdAmount:
        case AlertAttributeTypes.PurchaseExceedsThresholdAmount:
        case AlertAttributeTypes.GenerousTipPercentage:
            return (_jsx(AlertTextField, { alertId: alertId, inputKey: attributeKey, inputValue: attributes[attributeKey].value, inputError: dataErrors.find(function (error) { return error.key === attributeKey; })
                    ? getAttributeError(attributeKey).value
                    : '', inputRef: inputRef }));
        case AlertAttributeTypes.ReminderDueDays:
        case AlertAttributeTypes.PromoExpiryDays:
            return (_jsx(AlertSelectField, { alertId: alertId, inputKey: attributeKey, inputValue: attributes[attributeKey].value, inputError: dataErrors.find(function (error) { return error.key === attributeKey; })
                    ? getAttributeError(attributeKey).value
                    : '', isDisabled: !currentAlertData.attributes.find(function (att) { return att.key === attributeKey; })
                    .changeable, inputRef: inputRef }));
        default:
            return null;
    }
};
export default InputField;
